import {createAction, props} from '@ngrx/store';
import {GlobalConfigDTO} from '../../utils/dto/global-config';

export const loadGlobalConfig = createAction('[GlobalConfig] Load');

export const loadGlobalConfigSuccess = createAction(
  '[GlobalConfig] Load Success',
  props<{ config: GlobalConfigDTO }>()
);

export const loadGlobalConfigFailure = createAction(
  '[GlobalConfig] Load Failure',
  props<{ error: string }>()
);
